import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClockErrorSmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={101}
      height={69}
      fill="none"
      {...props}
    >
      <g clipPath="url(#clockErrorSmall_svg__a)">
        <circle
          cx={50.5}
          cy={34.409}
          r={28.409}
          stroke="url(#clockErrorSmall_svg__b)"
          strokeWidth={5.682}
        />
      </g>
      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.568}
        d="M50.5 18.5v15.91l8.523-9.092"
      />
      <rect width={22.159} height={22.159} x={17.261} y={6.466} fill="#DB646A" rx={11.079} />
      <rect
        width={22.159}
        height={22.159}
        x={17.261}
        y={6.466}
        stroke="#fff"
        strokeWidth={0.568}
        rx={11.079}
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.852}
        d="M28.34 14.136v3.978m0 1.704v.568"
      />
      <defs>
        <linearGradient
          id="clockErrorSmall_svg__b"
          x1={50.5}
          x2={50.5}
          y1={6}
          y2={62.818}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#F7D0D0" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="clockErrorSmall_svg__a">
          <rect width={56.818} height={56.818} x={21.807} y={6} fill="#fff" rx={28.409} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClockErrorSmall);
export default ForwardRef;
